import React from "react";
import { Typography } from "components";

const OnboardingHeader = ({ currentIndex }) => {
  const headerItems = [
    {
      id: 1,
      desktopLabel: "Personal Details",
      mobileLabel: "Personal",
    },
    {
      id: 2,
      desktopLabel: "Next of Kin Details",
      mobileLabel: "Next of Kin",
    },
    {
      id: 3,
      desktopLabel: "Guarantor Details",
      mobileLabel: "Guarantor",
    },
    {
      id: 4,
      desktopLabel: "Attach Documents",
      mobileLabel: "Documents",
    },
  ];

  return (
    <div>
      <div className="d-none d-md-flex justify-content-between">
        {headerItems.map(({ id, desktopLabel }) => (
          <div className={currentIndex === id ? "header-active" : ""} key={id}>
            <Typography state="primary" variant="body0">
              {desktopLabel}
            </Typography>
          </div>
        ))}
      </div>

      <div className="d-flex d-md-none justify-content-between">
        {headerItems.map(({ id, mobileLabel }) => (
          <div className={currentIndex === id ? "header-active" : ""} key={id}>
            <Typography
              state="primary"
              variant="body0"
              className={"cursor-pointer"}
            >
              {mobileLabel}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnboardingHeader;
